<div class="page-transition">

  <!-- 1. BANNER -->
  <section class="relative overflow-hidden">
    <div class="relative">
      <div class="flex transition-transform duration-700 ease-in-out" [style.transform]="'translateX(-' + (bannerIndex * 100) + '%)'">
        <div *ngFor="let slide of slides" class="w-full shrink-0">
          <img [src]="slide.image" [alt]="slide.alt" class="hidden md:block w-full h-auto object-cover" />
          <img [src]="slide.mobile_image" [alt]="slide.alt" class="md:hidden w-full h-auto object-cover" />
        </div>
      </div>
    </div>
    <!-- Banner bottom bar -->
    <div class="bg-[#600b0b] py-2.5 text-center">
      <p class="text-white text-[10px] md:text-xs uppercase tracking-[0.3em] font-medium">Ideation &nbsp; | &nbsp; Creation &nbsp; | &nbsp; Execution</p>
    </div>
  </section>

  <!-- 2. CONTENT AREA (Form + Why Choose) -->
  <section class="py-8 md:py-12 bg-white">
    <div class="max-w-[1200px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row gap-8 lg:gap-10">

      <!-- LEFT: Heading + Form (65%) -->
      <div class="lg:w-[63%]">
        <h2 class="text-lg md:text-xl font-bold text-gray-900 mb-1 text-center lg:text-left">Looking for Exclusive Wall Decor Solutions for Your Business?"</h2>
        <p class="text-gray-500 text-sm mb-5 text-center lg:text-left">Let us bring creativity to your space with custom art, wallpapers, and more!</p>

        <h3 class="text-base font-bold text-gray-800 mb-1 text-center lg:text-left">Register & Get a Free Art Consultation!</h3>
        <p class="text-gray-500 text-xs mb-6 text-center lg:text-left">Share your project details with us, and our experts will connect with you within 48 hours.</p>

        <!-- FORM -->
        <form [formGroup]="form" (ngSubmit)="submit()" class="border-2 border-[#600b0b] rounded-2xl p-5 md:p-8">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">

            <!-- Name -->
            <input formControlName="name" type="text" placeholder="Name *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <!-- Email -->
            <input formControlName="email" type="email" placeholder="Email *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <!-- Contact Number -->
            <input formControlName="contact" type="text" maxlength="10" placeholder="Contact Number *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <!-- OTP + Send OTP (same row) -->
            <div class="flex items-end gap-3">
              <input formControlName="otp" type="number" placeholder="OTP"
                class="flex-1 border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />
              <button type="button" (click)="sendOtp()" [disabled]="!canSendOtp"
                class="px-5 py-2.5 bg-gray-200 text-gray-600 text-[10px] uppercase tracking-[0.2em] font-bold hover:bg-[#600b0b] hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap shrink-0">
                {{ otpCountdown > 0 ? 'Resend (' + otpCountdown + 's)' : 'SEND OTP' }}
              </button>
            </div>

            <!-- Company Name -->
            <input formControlName="company" type="text" placeholder="Company Name *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <!-- Designation -->
            <select formControlName="designation"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('designation')?.value">
              <option value="" disabled class="text-gray-400">Designation *</option>
              <option *ngFor="let d of designations" [value]="d" class="text-gray-800">{{ d }}</option>
            </select>

            <!-- City -->
            <input formControlName="city" type="text" placeholder="City"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <!-- Are You -->
            <select formControlName="are_you" (change)="onAreYouChange()"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('are_you')?.value">
              <option value="" class="text-gray-400">Are You</option>
              <option *ngFor="let opt of areYouOptions" [value]="opt.value" class="text-gray-800">{{ opt.label }}</option>
            </select>

            <!-- Industry (only when are_you == 3 / Other) -->
            <select *ngIf="form.get('are_you')?.value === '3'" formControlName="industry" (change)="onIndustryChange()"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('industry')?.value">
              <option value="" class="text-gray-400">Which Industry</option>
              <option *ngFor="let ind of industries" [value]="ind" class="text-gray-800">{{ ind }}</option>
            </select>

            <!-- By Area (only when are_you == 2 / Interior Designer) -->
            <select *ngIf="form.get('are_you')?.value === '2'" formControlName="area"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('area')?.value">
              <option value="" class="text-gray-400">By Area</option>
              <option *ngFor="let a of areaOptions" [value]="a" class="text-gray-800">{{ a }}</option>
            </select>

            <!-- Spaces (multi-select dropdown) -->
            <div class="relative">
              <button type="button" (click)="spacesDropdownOpen = !spacesDropdownOpen"
                class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm text-left outline-none focus:border-[#600b0b] transition-colors flex items-center justify-between"
                [class.text-gray-400]="selectedSpaces.length === 0" [class.text-gray-800]="selectedSpaces.length > 0">
                <span class="truncate">{{ selectedSpaces.length > 0 ? selectedSpaces.join(', ') : 'Spaces' }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-gray-400 shrink-0 transition-transform" [class.rotate-180]="spacesDropdownOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>
              <div *ngIf="spacesDropdownOpen && spacesOptions.length > 0" class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-20 max-h-[200px] overflow-y-auto">
                <label *ngFor="let sp of spacesOptions" class="flex items-center gap-2.5 px-3 py-2 hover:bg-rose-50 cursor-pointer transition-colors text-sm">
                  <input type="checkbox" [checked]="selectedSpaces.includes(sp)" (change)="toggleSpace(sp)" class="w-3.5 h-3.5 accent-[#600b0b] cursor-pointer" />
                  <span class="text-gray-700">{{ sp }}</span>
                </label>
              </div>
            </div>

            <!-- Type of Art Work (multi-select dropdown) -->
            <div class="relative">
              <button type="button" (click)="artWorkDropdownOpen = !artWorkDropdownOpen"
                class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm text-left outline-none focus:border-[#600b0b] transition-colors flex items-center justify-between"
                [class.text-gray-400]="selectedArtWork.length === 0" [class.text-gray-800]="selectedArtWork.length > 0">
                <span class="truncate">{{ selectedArtWork.length > 0 ? selectedArtWork.join(', ') : 'Type of Art Work' }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-gray-400 shrink-0 transition-transform" [class.rotate-180]="artWorkDropdownOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>
              <div *ngIf="artWorkDropdownOpen" class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-20 max-h-[200px] overflow-y-auto">
                <label *ngFor="let art of artWorkOptions" class="flex items-center gap-2.5 px-3 py-2 hover:bg-rose-50 cursor-pointer transition-colors text-sm">
                  <input type="checkbox" [checked]="selectedArtWork.includes(art)" (change)="toggleArtWork(art)" class="w-3.5 h-3.5 accent-[#600b0b] cursor-pointer" />
                  <span class="text-gray-700">{{ art }}</span>
                </label>
              </div>
            </div>

            <!-- Required Time -->
            <div>
              <label class="text-[10px] font-medium text-[#600b0b] mb-0.5 block">Required Time</label>
              <select formControlName="time"
                class="w-full border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#600b0b] transition-colors bg-white appearance-none cursor-pointer text-gray-400"
                style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 8px center;"
                [class.text-gray-800]="form.get('time')?.value">
                <option value="" class="text-gray-400">--Select--</option>
                <option *ngFor="let t of timeOptions" [value]="t" class="text-gray-800">{{ t }}</option>
              </select>
            </div>

            <!-- Request Sample Art -->
            <div>
              <label class="text-[10px] font-medium text-[#600b0b] mb-0.5 block">Request for sample Art</label>
              <select formControlName="request_sample_art"
                class="w-full border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#600b0b] transition-colors bg-white appearance-none cursor-pointer text-gray-400"
                style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 8px center;"
                [class.text-gray-800]="form.get('request_sample_art')?.value">
                <option value="" class="text-gray-400">--Select--</option>
                <option *ngFor="let s of sampleOptions" [value]="s.value" class="text-gray-800">{{ s.label }}</option>
              </select>
            </div>
          </div>

          <!-- Submit -->
          <div class="mt-7">
            <button type="submit" [disabled]="form.invalid || isSubmitting"
              class="bg-[#600b0b] text-white px-10 py-3 rounded text-sm font-bold hover:bg-[#8c1c1c] disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              {{ isSubmitting ? 'Submitting...' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>

      <!-- RIGHT: Why Choose + Contact (35%) -->
      <div class="lg:w-[37%] space-y-8">
        <!-- Why Choose Mahatta Art -->
        <div>
          <h3 class="text-lg md:text-xl font-semibold text-gray-900 mb-1 text-center lg:text-left">Why Choose Mahatta Art?</h3>
          <div class="w-8 h-[1.5px] bg-[#600b0b]/30 mx-auto lg:mx-0 mt-1 mb-5"></div>

          <div class="space-y-4">
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">We Conceptualize, Create & Install</p>
                <p class="text-xs text-gray-500">A Complete solution under one roof.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">From Consultation to Execution</p>
                <p class="text-xs text-gray-500">Our expert Team handles every detail.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">Wide Range of Products</p>
                <p class="text-xs text-gray-500">WallArt, Wallpapers, wooden & metal decor, mirror art, sculptures, and more.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">Hassle-Free Pan India Delivery & Installation</p>
                <p class="text-xs text-gray-500">Sit back & relax while we do the work.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">Affordable Pricing & Corporate Packages</p>
                <p class="text-xs text-gray-500">Luxury wall decor made accessible.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">10+ Years of Experience | 50+ Projects Delivered</p>
                <p class="text-xs text-gray-500">Trusted by top designers & businesses.</p>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b] shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <div>
                <p class="text-sm font-semibold text-gray-800">After Sales Support</p>
                <p class="text-xs text-gray-500">We're here even after installation.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Contact Information -->
        <div class="text-center">
          <h3 class="text-lg md:text-xl font-semibold text-gray-900 mb-1">Contact Information</h3>
          <div class="w-8 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-1 mb-4"></div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-[#600b0b] mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          <p class="text-sm text-gray-700">For any information,</p>
          <p class="text-sm text-gray-700">Contact us at <span class="font-semibold">+91-8448997284</span> or</p>
          <p class="text-sm text-gray-700">Mail us at</p>
          <a href="mailto:corporatesales@mahattaart.com" class="text-sm text-[#600b0b] font-medium hover:underline">corporatesales@mahattaart.com</a>
        </div>
      </div>
    </div>
  </section>

  <!-- 3. HOW TO BUY WALLART -->
  <section class="py-10 md:py-14 bg-white">
    <div class="max-w-[1300px] mx-auto px-4 md:px-6 text-center">
      <h2 class="text-xl md:text-2xl font-semibold text-gray-900 mb-2">How To Buy WallArt?</h2>
      <!-- Decorative divider -->
      <div class="flex items-center justify-center gap-2 mb-10">
        <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
        <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
      </div>

      <!-- All 5 steps in one row -->
      <div class="flex flex-wrap justify-center gap-4 md:gap-0 md:flex-nowrap md:justify-between">
        <div *ngFor="let step of steps" class="flex flex-col items-center w-[140px] md:w-[18%]">
          <div class="w-[150px] h-[150px] md:w-[180px] md:h-[180px] mb-4">
            <img [src]="step.image" [alt]="step.label" class="w-full h-full object-contain" />
          </div>
          <p class="text-xs md:text-[13px] font-semibold text-[#600b0b] text-center">{{ step.label }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- 4. OUR CLIENTS -->
  <section class="py-10 md:py-14">
    <!-- Heading -->
    <div class="text-center mb-2">
      <h2 class="text-xl md:text-2xl font-semibold text-gray-900 mb-2">Our Clients</h2>
      <div class="flex items-center justify-center gap-2">
        <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
        <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
      </div>
    </div>

    <!-- Carousel (full width, beige bg) -->
    <div class="bg-[#f5f0ea] mt-6" (mouseenter)="stopClientTimer()" (mouseleave)="startClientTimer()">
      <div class="relative overflow-hidden">
        <div class="flex transition-transform duration-700 ease-in-out" [style.transform]="'translateX(-' + (clientIndex * 100) + '%)'">
          <div *ngFor="let cs of clientSlides" class="w-full shrink-0">
            <img [src]="cs.image" alt="Our Clients" class="hidden md:block w-full h-auto" />
            <img [src]="cs.mobile_image" alt="Our Clients" class="md:hidden w-full h-auto" />
          </div>
        </div>
      </div>
    </div>

    <!-- Dots (below the beige area) -->
    <div class="flex justify-center gap-2.5 mt-5">
      <button *ngFor="let cs of clientSlides; let i = index" (click)="goToClient(i)"
        class="w-2.5 h-2.5 rounded-full transition-all duration-300"
        [ngClass]="i === clientIndex ? 'bg-[#600b0b]' : 'bg-gray-300 hover:bg-gray-400'">
      </button>
    </div>
  </section>

  <!-- 5. WHY MAHATTAART -->
  <section class="py-8 md:py-12 bg-[#faf8f5]">
    <div class="max-w-[1200px] mx-auto px-4 md:px-6 text-center">
      <h2 class="text-xl md:text-2xl font-semibold text-gray-900 mb-1">Why MahattaArt ?</h2>
      <div class="w-8 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-1 mb-8"></div>

      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 md:gap-8">
        <div *ngFor="let item of whyItems" class="flex flex-col items-center group">
          <div class="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden mb-3 border border-gray-100 shadow-sm group-hover:shadow-md transition-shadow">
            <img [src]="item.icon" [alt]="item.label" class="w-full h-full object-contain" />
          </div>
          <p class="text-xs md:text-sm font-medium text-gray-700 text-center">{{ item.label }}</p>
        </div>
      </div>
    </div>
  </section>

</div>
